import { api as axios } from 'src/boot/axios';
import { LocalStorage } from 'quasar';
import { ResponseContext, type ResponseContextData } from 'src/core/api/ProviderContext';

export default async function (params: any, method = 'POST'): Promise<ResponseContextData> {
  try {
    // Token 'ı varsayılan olarak gönder
    const userToken = LocalStorage.getItem('user-token');

    const reqUrl = `${axios.defaults.baseURL}?m=${params.methodName}`;
    const response = await axios({
      url: reqUrl,
      data: { data: params },
      method: method,
      headers: {
        Authorization: userToken ? `Bearer ${userToken}` : null,
      },
      // auth: {
      //   username: 'gokhankrll',
      //   password: '3687412',
      // },
    });
    const {
      data: { status, message, data },
    } = response;

    return ResponseContext(status, message, data);
  } catch (err) {
    console.error('error', err);
  }
}
